import { Attributes, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class BankTransferLetterCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public entityId: number | null = null;

    @Attributes.Nullable()
    public dividendAccrualId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Bank Transfer Letter Criteria";
    }
}